import React, { useContext, useState } from 'react';
import { useThrottledCallback, useWindowResize } from 'beautiful-react-hooks';

import { media } from 'context';

import Item, { Props as ItemProps } from './Item';
import Layout from '../Layout';

interface Props {
  items: ItemProps[];
  columns: 1 | 2;
  gapX?: number;
}

const Accordion: React.FC<Props> = ({ items, columns, ...props }) => {
  const [windowWidth, setWindowWidth] = useState<number>(0);
  const { xs, sm, md, lg } = useContext(media);
  const onWindowResize = useWindowResize();

  onWindowResize(
    useThrottledCallback(
      _event => {
        setWindowWidth(window.innerWidth);
      },
      [],
      250
    )
  );

  const midLength = Math.round(items.length / 2);
  const leftSide = items.slice(0, midLength);
  const rightSide = items.slice(midLength);
  const twoColumns = columns === 2;
  const gapX = props.gapX || (lg ? 88 : md ? 64 : sm ? 40 : undefined);

  return (
    <Layout>
      <Layout direction={xs ? 'column' : twoColumns ? 'row' : 'column'} gap={columns === 2 ? gapX : undefined}>
        <Layout equalWidth>
          {leftSide.map(({ title, body }, i) => (
            <Item title={title} body={body} key={i + windowWidth} />
          ))}
        </Layout>
        <Layout equalWidth>
          {rightSide.map(({ title, body }, i) => (
            <Item title={title} body={body} key={i + windowWidth} />
          ))}
        </Layout>
      </Layout>
    </Layout>
  );
};

export default Accordion;
